import React from "react";
import { Col, FormFeedback, Label, Row } from "reactstrap";

export interface FormFieldRowProps {
    label: string;
    children: React.ReactNode;
    error?: string;
    hidden?: boolean;
    required?: boolean;
}

const labelStyle = {
    fontWeight: 600,
    color: "var(--color-text-strong)",
    paddingTop: "var(--space-tight-padding)",
} as const;

export const FormFieldRow = (props: FormFieldRowProps) => {
    if (props.hidden) return null;

    return (
        <Row className="align-items-start mb-3">
            <Col xs={12} md={3}>
                <Label style={labelStyle}>
                    {props.label}
                    {props.required && (
                        <span
                            aria-hidden="true"
                            style={{ color: "var(--color-danger)", marginLeft: 4 }}
                        >
                            *
                        </span>
                    )}
                </Label>
            </Col>
            <Col xs={12} md={9}>
                {props.children}
                {props.error && (
                    <FormFeedback style={{ display: "block" }}>
                        {props.error}
                    </FormFeedback>
                )}
            </Col>
        </Row>
    );
};